import * as React from 'react';
import { Link } from 'react-router-dom';
import { KeyboardArrowRight } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import TextStyles, { fontFamilies } from '../theme/text';
import { blue } from '../theme/colors';
import clsx from 'clsx';

export interface Breadcrumb {
  /** Title for a breadcrumb */
  title: string;
  /** Link path for a breadcrumb */
  path: string;
}

export interface BreadcrumbProps {
  /** Name of the current page, displayed as the last breadcrumb. Alternatively, another element, as in the selectable breadcrumb.*/
  currentPage: string | number | React.ReactElement;
  /** Array of `{title, path}` objects for each link before current page breadcrumb */
  breadcrumbs: Breadcrumb[];
  /** Classname for extra styles */
  className?: string;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      margin: '0 13px'
    },
    '& a': {
      fontFamily: fontFamilies.heading,
      textDecoration: 'none',
      fontSize: TextStyles.h1.fontSize,
      color: blue[600]
    },
    '& p': {
      ...TextStyles.h1,
      margin: 0
    }
  }
});

/**
 * Breadcrumbs show the user their location in the information architecture relative to the current page, generally used in multi-level views
 */
const Breadcrumbs = ({ breadcrumbs, currentPage, className }: BreadcrumbProps) => {
  const classes = useStyles();

  /**
   * @function renderBreadcrumbs - Renders each individual link/title and arrow
   */
  const renderBreadcrumbs = () => {
    return breadcrumbs.map((breadcrumb, index) => (
      // Full syntax for fragment needed in order to complete build
      <React.Fragment key={`breadcrumb-${index}`}>
        <Link to={breadcrumb.path}>{breadcrumb.title}</Link>
        <KeyboardArrowRight />
      </React.Fragment>
    ));
  };

  return (
    <div className={clsx(classes.root, className)}>
      {renderBreadcrumbs()}
      {typeof currentPage === 'string' || typeof currentPage === 'number' ? (
        <p>{currentPage}</p>
      ) : (
        currentPage
      )}
    </div>
  );
};

export default Breadcrumbs;
